app.run();



// WEBPACK FOOTER //
// ./resources/assets/js/app/run.js